<div class="input-group mb-4">
    <input type="text" class="form-control form-control-lg" placeholder="Suche in Dokumenttext.." (keyup.enter)="createConfig()" [(ngModel)]="search">
    <div class="input-group-append">
        <button class="btn btn-primary" type="button" (click)="createConfig()">Suchen</button>
    </div>
</div>

<app-table [config]="tableConfig"/>
